import { render, staticRenderFns } from "./NotificationsV2.vue?vue&type=template&id=00b7ca2b"
import script from "./NotificationsV2.vue?vue&type=script&lang=js"
export * from "./NotificationsV2.vue?vue&type=script&lang=js"
import style0 from "./NotificationsV2.vue?vue&type=style&index=0&id=00b7ca2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QSpinner,QDialog,QCard,QCardSection,QAvatar,QCardActions,QBtn});qInstall(component, 'directives', {ClosePopup});
